import omit from 'lodash/omit';

import {
  REMOVE_FAVORITE_REQUEST,
  GET_FAVORITES_REQUEST,
  GET_FAVORITES_RESPONSE,
  GET_FAVORITES_ERROR,
  ADD_FAVORITE_RESPONSE,
} from 'actions/favorites';

const defaultState = { data: {} };

export default (state = defaultState, action) => {
  const { type, response, params } = action;

  switch (type) {
    case REMOVE_FAVORITE_REQUEST:
      return { ...state, data: omit(state.data, params.mealConcept) };
    case GET_FAVORITES_REQUEST:
      return { ...state, isLoading: true };
    case GET_FAVORITES_ERROR:
      return { ...state, isLoading: false, isError: true };
    case GET_FAVORITES_RESPONSE:
      return {
        ...state,
        data: { ...state.data, ...response.favorites },
        isLoading: false,
        isError: false,
        isFetched: true,
      };
    case ADD_FAVORITE_RESPONSE:
      return { ...state, data: { ...state.data, ...response.favorite } };
    default:
      return state;
  }
};
